(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7729],{

/***/ 40965:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgKantanIcon = function SvgKantanIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M7.4 13.233h9.2a.6.6 0 0 1 .6.6v1.2c0 2.87-2.33 5.2-5.2 5.2s-5.2-2.33-5.2-5.2v-1.2a.6.6 0 0 1 .6-.6ZM12 10.767a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z"
  }))));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgKantanIcon);

/***/ }),

/***/ 5925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_image_lightbox__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92879);
/* harmony import */ var _Lightbox_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57271);
/* harmony import */ var _Lightbox_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Lightbox_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);






var Lightbox = function Lightbox(_ref) {
  var images = _ref.images,
      _ref$alt = _ref.alt,
      alt = _ref$alt === void 0 ? '' : _ref$alt;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0),
      currentPhotoIndex = _useState2[0],
      setCurrentPhotoIndex = _useState2[1];

  var currentPhoto = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return images[currentPhotoIndex];
  }, [images, currentPhotoIndex]);
  var onClickOpen = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (index) {
    setIsOpen(true);
    setCurrentPhotoIndex(index);
  }, []);

  var _onMovePrevRequest = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    var prev = currentPhotoIndex - 1 < 0 ? images.length - 1 : currentPhotoIndex - 1;
    setCurrentPhotoIndex(prev);
  }, [images, currentPhotoIndex]);

  var _onMoveNextRequest = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    var next = currentPhotoIndex + 1 >= images.length ? 0 : currentPhotoIndex + 1;
    setCurrentPhotoIndex(next);
  }, [images, currentPhotoIndex]);

  if (images.length === 0) {
    return null;
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
    className: (_Lightbox_module_scss__WEBPACK_IMPORTED_MODULE_3___default().Lightbox),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
      className: (_Lightbox_module_scss__WEBPACK_IMPORTED_MODULE_3___default().Lightbox__List),
      children: images.map(function (image, i) {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("button", {
          className: (_Lightbox_module_scss__WEBPACK_IMPORTED_MODULE_3___default().Lightbox__Button),
          type: "button",
          onClick: function onClick() {
            return onClickOpen(i);
          },
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("img", {
            className: (_Lightbox_module_scss__WEBPACK_IMPORTED_MODULE_3___default().Lightbox__Thumbnail),
            src: image.thumbUrl,
            alt: alt
          })
        }, image.mainUrl);
      })
    }), isOpen && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_image_lightbox__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      mainSrc: currentPhoto.mainUrl,
      prevSrc: (images[currentPhotoIndex - 1] || images[images.length - 1]).mainUrl,
      nextSrc: (images[currentPhotoIndex + 1] || images[0]).mainUrl,
      onCloseRequest: function onCloseRequest() {
        return setIsOpen(false);
      },
      onMovePrevRequest: function onMovePrevRequest() {
        return _onMovePrevRequest();
      },
      onMoveNextRequest: function onMoveNextRequest() {
        return _onMoveNextRequest();
      },
      enableZoom: false
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Lightbox);

/***/ }),

/***/ 72314:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Cp": function() { return /* binding */ allCategoriesCache; },
  "n3": function() { return /* binding */ getCategory; }
});

// UNUSED EXPORTS: InvalidCategoryIdError, InvalidGeoIdError

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(82262);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(92777);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__(81531);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(63553);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(37247);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/wrapNativeSuper.js + 3 modules
var wrapNativeSuper = __webpack_require__(46576);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./node_modules/fp-ts/es6/Array.js + 3 modules
var es6_Array = __webpack_require__(69164);
// EXTERNAL MODULE: ./node_modules/fp-ts/es6/Either.js + 1 modules
var Either = __webpack_require__(30365);
// EXTERNAL MODULE: ./node_modules/fp-ts/es6/function.js
var es6_function = __webpack_require__(3735);
// EXTERNAL MODULE: ./node_modules/fp-ts/es6/Map.js + 1 modules
var Map = __webpack_require__(60387);
// EXTERNAL MODULE: ./node_modules/fp-ts/es6/number.js
var number = __webpack_require__(24011);
// EXTERNAL MODULE: ./node_modules/fp-ts/es6/Option.js + 1 modules
var Option = __webpack_require__(27135);
// EXTERNAL MODULE: ./node_modules/fp-ts/es6/Semigroup.js + 1 modules
var Semigroup = __webpack_require__(90153);
// EXTERNAL MODULE: ./node_modules/io-ts/es6/PathReporter.js
var PathReporter = __webpack_require__(62367);
// EXTERNAL MODULE: ./src/utils/apiroot.ts
var apiroot = __webpack_require__(36057);
// EXTERNAL MODULE: ./node_modules/io-ts/es6/index.js
var es6 = __webpack_require__(32521);
;// CONCATENATED MODULE: ./src/infrastructure/api/exploreApiValidators.ts

var CategoryEntityValidator = es6/* type */.dt({
  categoryId: es6/* number */.pk,
  nameJa: es6/* string */.Z_,
  imageUrl: es6/* string */.Z_
});
var CategoryArrayValidator = es6/* array */.IX(CategoryEntityValidator);
var AllCategoriesValidator = es6/* type */.dt({
  categories: CategoryArrayValidator
});
;// CONCATENATED MODULE: ./src/infrastructure/api/backend/explore_api.ts









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }












var InvalidGeoIdError = /*#__PURE__*/function (_Error) {
  (0,inherits/* default */.Z)(InvalidGeoIdError, _Error);

  var _super = _createSuper(InvalidGeoIdError);

  function InvalidGeoIdError(e) {
    (0,classCallCheck/* default */.Z)(this, InvalidGeoIdError);

    return _super.call(this, e);
  }

  return (0,createClass/* default */.Z)(InvalidGeoIdError);
}( /*#__PURE__*/(0,wrapNativeSuper/* default */.Z)(Error));
var InvalidCategoryIdError = /*#__PURE__*/function (_Error2) {
  (0,inherits/* default */.Z)(InvalidCategoryIdError, _Error2);

  var _super2 = _createSuper(InvalidCategoryIdError);

  function InvalidCategoryIdError(e) {
    (0,classCallCheck/* default */.Z)(this, InvalidCategoryIdError);

    return _super2.call(this, e);
  }

  return (0,createClass/* default */.Z)(InvalidCategoryIdError);
}( /*#__PURE__*/(0,wrapNativeSuper/* default */.Z)(Error));
var instance = axios_default().create({
  baseURL: (0,apiroot/* apiRoot */.b)(),
  headers: {
    'Content-Type': 'application/json; charset=UTF-8',
    Accept: 'application/json'
  }
});
/**
 * rails側に移行したものは即エラーとする
 * @param validator
 * @param res
 */

var strictJsonValidator = function strictJsonValidator(validator, _ref) {
  var data = _ref.data;
  var result = validator.decode(data);

  if ((0,Either/* isRight */.tO)(result)) {
    return result.right;
  } else {
    var report = PathReporter/* PathReporter.report */.qq.report(result);
    throw Error("".concat(report, "\n").concat(data));
  }
}; // カテゴリの更新頻度は非常に低いためNode内部でキャッシュしても問題ないと判断した


var getAllCategories = /*#__PURE__*/function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
    var res, _strictJsonValidator, categories;

    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return instance.get("/explore/all_categories");

          case 2:
            res = _context.sent;
            _strictJsonValidator = strictJsonValidator(AllCategoriesValidator, res), categories = _strictJsonValidator.categories;
            return _context.abrupt("return", categories);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getAllCategories() {
    return _ref2.apply(this, arguments);
  };
}();

var _allCategoriesCache = undefined;
var allCategoriesCache = /*#__PURE__*/function () {
  var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!_allCategoriesCache) {
              _allCategoriesCache = getAllCategories();
            }

            return _context2.abrupt("return", _allCategoriesCache);

          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function allCategoriesCache() {
    return _ref3.apply(this, arguments);
  };
}(); // 個別カテゴリ取得

var buildCategoryMap = /*#__PURE__*/function () {
  var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3() {
    return regenerator_default().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.t0 = es6_function/* pipe */.zG;
            _context3.next = 3;
            return allCategoriesCache();

          case 3:
            _context3.t1 = _context3.sent;
            _context3.t2 = (0,es6_Array/* map */.UI)(function (c) {
              return [c.categoryId, c];
            });
            _context3.t3 = (0,Map/* fromFoldable */.sQ)(number.Eq, (0,Semigroup/* first */.Ps)(), es6_Array/* Foldable */.$6);
            return _context3.abrupt("return", (0, _context3.t0)(_context3.t1, _context3.t2, _context3.t3));

          case 7:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function buildCategoryMap() {
    return _ref4.apply(this, arguments);
  };
}();

var _categoryMap = undefined;
var getCategory = /*#__PURE__*/function () {
  var _ref5 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4(categoryId) {
    var result;
    return regenerator_default().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (!_categoryMap) {
              _categoryMap = buildCategoryMap();
            }

            _context4.t0 = (0,Map/* lookup */.P5)(number.Eq)(categoryId);
            _context4.next = 4;
            return _categoryMap;

          case 4:
            _context4.t1 = _context4.sent;
            result = (0, _context4.t0)(_context4.t1);

            if (!(0,Option/* isSome */.pC)(result)) {
              _context4.next = 10;
              break;
            }

            return _context4.abrupt("return", result.value);

          case 10:
            throw new InvalidCategoryIdError("No such categoryId: ".concat(categoryId));

          case 11:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function getCategory(_x) {
    return _ref5.apply(this, arguments);
  };
}();

/***/ }),

/***/ 90455:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_linkify__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44778);
/* harmony import */ var _components_utils_StringUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16197);
/* harmony import */ var _DescriptionPanel_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52890);
/* harmony import */ var _DescriptionPanel_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_DescriptionPanel_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);





 // react-draft-wysiwygをそのまま使用するとReferenceError: window is not definedが発生するため


var RichViewer = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(6925), __webpack_require__.e(9041), __webpack_require__.e(6421)]).then(__webpack_require__.bind(__webpack_require__, 36421));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(36421)];
    }
  }
});

var MerchantCourseDetailsDescription = function MerchantCourseDetailsDescription(_ref) {
  var description = _ref.description,
      description_text = _ref.description_text,
      is_json_description = _ref.is_json_description;
  var classes = classnames__WEBPACK_IMPORTED_MODULE_0___default()((_DescriptionPanel_module_scss__WEBPACK_IMPORTED_MODULE_6___default().DescriptionPanel));
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
    className: classes,
    children: is_json_description && description ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(RichViewer, {
      value: description
    }) : description_text && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(react_linkify__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
      children: _components_utils_StringUtils__WEBPACK_IMPORTED_MODULE_4__/* ["default"].simpleFormat */ .Z.simpleFormat(description_text)
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (MerchantCourseDetailsDescription);

/***/ }),

/***/ 2667:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(16835);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(86896);
/* harmony import */ var xss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68924);
/* harmony import */ var xss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(xss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_LineTruncate__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56922);
/* harmony import */ var _components_utils_StringUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16197);
/* harmony import */ var _TruncateTextWithButton_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(51356);
/* harmony import */ var _TruncateTextWithButton_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_TruncateTextWithButton_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);











var TruncateTextWithButton = function TruncateTextWithButton(_ref) {
  var className = _ref.className,
      text = _ref.text,
      maxLine = _ref.maxLine;
  var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)();

  var _React$useState = react__WEBPACK_IMPORTED_MODULE_1__.useState(true),
      _React$useState2 = (0,_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_React$useState, 2),
      ellipsis = _React$useState2[0],
      setEllipsis = _React$useState2[1];

  var _React$useState3 = react__WEBPACK_IMPORTED_MODULE_1__.useState(true),
      _React$useState4 = (0,_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_React$useState3, 2),
      clampedState = _React$useState4[0],
      setClampedState = _React$useState4[1];

  var classes = classnames__WEBPACK_IMPORTED_MODULE_0___default()((_TruncateTextWithButton_module_scss__WEBPACK_IMPORTED_MODULE_8___default().TruncateTextWithButton), className);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
    className: classes,
    children: [ellipsis ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_components_LineTruncate__WEBPACK_IMPORTED_MODULE_3__/* .MultipleLineTruncate */ .Q, {
      className: (_TruncateTextWithButton_module_scss__WEBPACK_IMPORTED_MODULE_8___default().TruncateTextWithButton__Text),
      maxLine: maxLine,
      onReflow: function onReflow(_ref2) {
        var clamped = _ref2.clamped;
        return setClampedState(!!clamped);
      },
      text: text
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
      className: (_TruncateTextWithButton_module_scss__WEBPACK_IMPORTED_MODULE_8___default().TruncateTextWithButton__Text),
      dangerouslySetInnerHTML: {
        __html: _components_utils_StringUtils__WEBPACK_IMPORTED_MODULE_4__/* ["default"].nl2brString */ .Z.nl2brString((0,xss__WEBPACK_IMPORTED_MODULE_2__.filterXSS)(text))
      }
    }), clampedState && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("button", {
      className: (_TruncateTextWithButton_module_scss__WEBPACK_IMPORTED_MODULE_8___default().TruncateTextWithButton__Button),
      onClick: function onClick(ev) {
        ev.preventDefault();
        setEllipsis(!ellipsis);
      },
      children: ellipsis ? intl.formatMessage({
        id: 'merchants.truncateTextWithButton.truncateOpen'
      }) : intl.formatMessage({
        id: 'merchants.truncateTextWithButton.truncateClose'
      })
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (TruncateTextWithButton);

/***/ }),

/***/ 17132:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86896);
/* harmony import */ var _LowestPrice_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92706);
/* harmony import */ var _LowestPrice_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_LowestPrice_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);








var LowestPrice = function LowestPrice(props) {
  var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
  return props.lowestPrice == null ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {}) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("span", {
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()((_LowestPrice_module_scss__WEBPACK_IMPORTED_MODULE_4___default().LowestPrice), props.className),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
      className: (_LowestPrice_module_scss__WEBPACK_IMPORTED_MODULE_4___default().LowestPrice__Emphasis),
      children: intl.formatNumber(props.lowestPrice)
    }), intl.formatMessage({
      id: props.uniquePricing ? 'merchants.common.lowestPrice.single_unit' : 'merchants.common.lowestPrice.multi_unit'
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (LowestPrice);

/***/ }),

/***/ 56020:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _resource_id_; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/layouts/JsonLd.tsx
var JsonLd = __webpack_require__(26411);
// EXTERNAL MODULE: ./src/components/layouts/MetaTags.tsx
var MetaTags = __webpack_require__(92651);
// EXTERNAL MODULE: ./src/components/MerchantSite/index.tsx
var MerchantSite = __webpack_require__(7818);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(86896);
// EXTERNAL MODULE: ./src/molecules/merchant/resources/book/BooksNotes/index.tsx
var BooksNotes = __webpack_require__(26854);
// EXTERNAL MODULE: ./src/domain/entities/BookingPage.ts
var BookingPage = __webpack_require__(1885);
// EXTERNAL MODULE: ./src/interfaces/merchants/bookings/index.ts
var bookings = __webpack_require__(10592);
// EXTERNAL MODULE: ./src/atoms/buttons/Button/index.tsx
var Button = __webpack_require__(48413);
// EXTERNAL MODULE: ./src/components/Lightbox/index.tsx
var Lightbox = __webpack_require__(5925);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/molecules/common/GoogleMap/GoogleMap.module.scss
var GoogleMap_module = __webpack_require__(97930);
var GoogleMap_module_default = /*#__PURE__*/__webpack_require__.n(GoogleMap_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/molecules/common/GoogleMap/index.tsx







var GoogleMap = function GoogleMap(_ref) {
  var displayName = _ref.displayName,
      mapData = _ref.mapData;
  var classes = classnames_default()((GoogleMap_module_default()).GoogleMap);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: classes,
    children: [mapData.href ? /*#__PURE__*/(0,jsx_runtime.jsx)("address", {
      className: (GoogleMap_module_default()).GoogleMap__Address,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
        href: mapData.href,
        prefetch: false,
        children: mapData.address_city
      })
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)("address", {
      className: (GoogleMap_module_default()).GoogleMap__Address,
      children: mapData.address_city
    }), mapData.img_src && /*#__PURE__*/(0,jsx_runtime.jsx)("figure", {
      className: (GoogleMap_module_default()).GoogleMap__Image,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        src: mapData.img_src,
        alt: displayName
      })
    })]
  });
};

/* harmony default export */ var common_GoogleMap = (GoogleMap);
// EXTERNAL MODULE: ./src/molecules/merchant/reviews/ReviewList/index.tsx + 2 modules
var ReviewList = __webpack_require__(98904);
// EXTERNAL MODULE: ./src/atoms/Heading/index.tsx
var Heading = __webpack_require__(44407);
// EXTERNAL MODULE: ./src/organisms/merchants/BaseTemplate/index.tsx + 6 modules
var BaseTemplate = __webpack_require__(74831);
// EXTERNAL MODULE: ./src/molecules/merchant/DescriptionPanel/index.tsx
var DescriptionPanel = __webpack_require__(90455);
// EXTERNAL MODULE: ./src/helpers/merchants/resources/helper.tsx
var helper = __webpack_require__(18904);
// EXTERNAL MODULE: ./src/molecules/merchant/MerchantProfile/index.tsx + 1 modules
var MerchantProfile = __webpack_require__(30446);
// EXTERNAL MODULE: ./src/molecules/merchant/common/buttons/TruncateTextWithButton/index.tsx
var TruncateTextWithButton = __webpack_require__(2667);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(44012);
// EXTERNAL MODULE: ./src/components/LineTruncate/index.tsx
var LineTruncate = __webpack_require__(56922);
// EXTERNAL MODULE: ./src/templates/merchants/resources/DetailTemplate/components/Appointment/CourseDetail.module.scss
var CourseDetail_module = __webpack_require__(90501);
var CourseDetail_module_default = /*#__PURE__*/__webpack_require__.n(CourseDetail_module);
;// CONCATENATED MODULE: ./src/templates/merchants/resources/DetailTemplate/components/Appointment/CourseDetail.tsx








var CourseDetail = function CourseDetail(_ref) {
  var menuName = _ref.menuName,
      price = _ref.price,
      duration = _ref.duration;
  var classes = classnames_default()((CourseDetail_module_default()).CourseDetail);
  var intl = (0,useIntl/* default */.Z)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: classes,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LineTruncate/* SingleLineTruncate */.d, {
      maxLine: 2,
      text: menuName
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
      className: (CourseDetail_module_default()).CourseDetail__Detail,
      children: [duration && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: (CourseDetail_module_default()).CourseDetail__Time,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
          id: "merchants.bookingPages.courseDetail.time",
          values: {
            time: intl.formatNumber(duration / 60)
          }
        })
      }), price && /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
        id: "merchants.bookingPages.courseDetail.price",
        values: {
          price: price
        }
      })]
    })]
  });
};

/* harmony default export */ var Appointment_CourseDetail = (CourseDetail);
// EXTERNAL MODULE: ./src/templates/merchants/resources/DetailTemplate/components/Appointment/Course.module.scss
var Course_module = __webpack_require__(63623);
var Course_module_default = /*#__PURE__*/__webpack_require__.n(Course_module);
;// CONCATENATED MODULE: ./src/templates/merchants/resources/DetailTemplate/components/Appointment/Course.tsx











var Course = function Course(_ref) {
  var courseName = _ref.courseName,
      image = _ref.image,
      price = _ref.price,
      text = _ref.text,
      duration = _ref.duration,
      href = _ref.href;
  var intl = (0,useIntl/* default */.Z)();
  var classes = classnames_default()((Course_module_default()).Course);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: classes,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (Course_module_default()).Course__Header,
      children: [image && image.thumb && image.thumb.url && /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        className: (Course_module_default()).Course__Image,
        src: image.thumb.url,
        alt: ""
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Appointment_CourseDetail, {
        menuName: courseName,
        price: price,
        duration: duration
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (Course_module_default()).Course__Description,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TruncateTextWithButton/* default */.Z, {
        text: text,
        maxLine: 7
      }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
        href: href,
        prefetch: false,
        legacyBehavior: true,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.ZP, {
          className_Deprecated: (Course_module_default()).Course__Button,
          href: href,
          isGhost: true,
          children: intl.formatMessage({
            id: 'merchants.bookingPages.course.select'
          })
        })
      })]
    })]
  });
};

/* harmony default export */ var Appointment_Course = (Course);
// EXTERNAL MODULE: ./src/templates/merchants/resources/DetailTemplate/components/Appointment/Staff.module.scss
var Staff_module = __webpack_require__(29269);
var Staff_module_default = /*#__PURE__*/__webpack_require__.n(Staff_module);
;// CONCATENATED MODULE: ./src/templates/merchants/resources/DetailTemplate/components/Appointment/Staff.tsx










var Staff = function Staff(_ref) {
  var staffName = _ref.staffName,
      image = _ref.image,
      description = _ref.description,
      href = _ref.href;
  var intl = (0,useIntl/* default */.Z)();
  var classes = classnames_default()((Staff_module_default()).Staff);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: classes,
    "data-style": description ? 'wrap' : 'noWrap',
    children: [image && image.url && /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
      className: (Staff_module_default()).Staff__Img,
      alt: staffName,
      src: image.url
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (Staff_module_default()).Staff__Texts,
      "data-style": image && image.url && 'hasImage',
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: (Staff_module_default()).Staff__Name,
        children: staffName
      }), description && /*#__PURE__*/(0,jsx_runtime.jsx)(TruncateTextWithButton/* default */.Z, {
        className: (Staff_module_default()).Staff__Description,
        text: description,
        maxLine: 7
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (Staff_module_default()).Staff__ButtonContainer,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
        href: href,
        prefetch: false,
        legacyBehavior: true,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.ZP, {
          href: href,
          isGhost: true,
          className_Deprecated: (Staff_module_default()).Staff__Button,
          children: intl.formatMessage({
            id: 'merchants.bookingPages.staff.select'
          })
        })
      })
    })]
  });
};

/* harmony default export */ var Appointment_Staff = (Staff);
// EXTERNAL MODULE: ./node_modules/lodash-es/camelCase.js + 10 modules
var camelCase = __webpack_require__(20320);
// EXTERNAL MODULE: ./src/molecules/merchant/common/buttons/SwitchContainerButton/SwitchContainerButton.module.scss
var SwitchContainerButton_module = __webpack_require__(38267);
var SwitchContainerButton_module_default = /*#__PURE__*/__webpack_require__.n(SwitchContainerButton_module);
;// CONCATENATED MODULE: ./src/molecules/merchant/common/buttons/SwitchContainerButton/index.tsx


var _excluded = ["label"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var SwitchContainerButton = function SwitchContainerButton(_ref) {
  var label = _ref.label,
      radioProps = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var classes = classnames_default()((SwitchContainerButton_module_default()).SwitchContainerButton);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
    className: classes,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", _objectSpread({
      type: "radio",
      className: classnames_default()((SwitchContainerButton_module_default()).SwitchContainerButton__Input, (0,defineProperty/* default */.Z)({}, (SwitchContainerButton_module_default()).isSelected, radioProps.checked))
    }, radioProps)), /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
      className: (SwitchContainerButton_module_default()).SwitchContainerButton__Label,
      htmlFor: radioProps.id,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        children: label || radioProps.value
      })
    })]
  });
};

/* harmony default export */ var buttons_SwitchContainerButton = (SwitchContainerButton);
// EXTERNAL MODULE: ./src/templates/merchants/resources/DetailTemplate/components/Appointment/SwitchCourseStaff.module.scss
var SwitchCourseStaff_module = __webpack_require__(79038);
var SwitchCourseStaff_module_default = /*#__PURE__*/__webpack_require__.n(SwitchCourseStaff_module);
;// CONCATENATED MODULE: ./src/templates/merchants/resources/DetailTemplate/components/Appointment/SwitchCourseStaff.tsx








var SwitchCourseStaff = function SwitchCourseStaff(_ref) {
  var selected = _ref.selected,
      onClick = _ref.onClick;
  var intl = (0,useIntl/* default */.Z)();
  var selections = Object.values(SwitchType);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (SwitchCourseStaff_module_default()).SwitchCourseStaff,
    children: selections.map(function (selection) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(buttons_SwitchContainerButton, {
        name: "switch",
        id: selection,
        label: intl.formatMessage({
          id: "merchants.bookingPages.switchCourseStaff.".concat((0,camelCase/* default */.Z)(selection))
        }),
        onChange: function onChange(e) {
          e.preventDefault();
          onClick(selection);
        },
        checked: selection === selected
      }, selection);
    })
  });
};

/* harmony default export */ var Appointment_SwitchCourseStaff = (SwitchCourseStaff);
// EXTERNAL MODULE: ./src/templates/merchants/resources/DetailTemplate/components/Appointment/index.module.scss
var index_module = __webpack_require__(35490);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ./src/templates/merchants/resources/DetailTemplate/components/Appointment/index.tsx









var SwitchType;

(function (SwitchType) {
  SwitchType["Course"] = "course";
  SwitchType["Staff"] = "staff";
})(SwitchType || (SwitchType = {}));

var Appointment = function Appointment(_ref) {
  var nickname = _ref.nickname,
      resourceId = _ref.resourceId,
      courses = _ref.courses,
      staff = _ref.staff;
  var classes = classnames_default()((index_module_default()).Appointment);
  var bookingPath = "/".concat(nickname, "/").concat(resourceId, "/book");

  var _React$useState = react.useState(SwitchType.Course),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      switchType = _React$useState2[0],
      setSwitchType = _React$useState2[1];

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: classes,
    children: [staff.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(Appointment_SwitchCourseStaff, {
      selected: switchType,
      onClick: setSwitchType
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (index_module_default()).Appointment__Content,
      children: [switchType === SwitchType.Course && courses.length > 0 && courses.map(function (c) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(Appointment_Course, {
          courseName: c.name,
          image: c.image,
          price: c.price,
          duration: c.duration,
          text: c.description,
          href: "".concat(bookingPath, "?selected_course=").concat(c.id)
        }, c.canonical_id);
      }), switchType === SwitchType.Staff && staff.length > 0 && staff.map(function (s) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(Appointment_Staff, {
          staffName: s.name,
          image: s.image,
          description: s.description,
          href: "".concat(bookingPath, "?selected_staff=").concat(s.id)
        }, s.canonical_id);
      })]
    })]
  });
};

/* harmony default export */ var components_Appointment = (Appointment);
// EXTERNAL MODULE: ./src/templates/merchants/resources/DetailTemplate/MerchantBookingServiceShowPage.module.scss
var MerchantBookingServiceShowPage_module = __webpack_require__(5470);
var MerchantBookingServiceShowPage_module_default = /*#__PURE__*/__webpack_require__.n(MerchantBookingServiceShowPage_module);
// EXTERNAL MODULE: ./src/atoms/icons/StarRating/index.tsx
var StarRating = __webpack_require__(98150);
// EXTERNAL MODULE: ./src/molecules/merchant/common/tags/MerchantTag/index.tsx
var MerchantTag = __webpack_require__(32409);
// EXTERNAL MODULE: ./src/molecules/merchant/common/texts/LowestPrice/index.tsx
var LowestPrice = __webpack_require__(17132);
// EXTERNAL MODULE: ./src/molecules/merchant/resources/book/MerchantCourseDetailsReservationButton/MerchantCourseDetailsReservationButton.module.scss
var MerchantCourseDetailsReservationButton_module = __webpack_require__(725);
var MerchantCourseDetailsReservationButton_module_default = /*#__PURE__*/__webpack_require__.n(MerchantCourseDetailsReservationButton_module);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/molecules/merchant/resources/book/MerchantCourseDetailsReservationButton/index.tsx









var MerchantCourseDetailsReservationButton = function MerchantCourseDetailsReservationButton(_ref) {
  var isBookable = _ref.isBookable,
      nickname = _ref.nickname,
      public_id = _ref.public_id,
      contactUrl = _ref.contactUrl;
  var intl = (0,useIntl/* default */.Z)();
  var classes = classnames_default()((MerchantCourseDetailsReservationButton_module_default()).MerchantCourseDetailsReservationButton);
  var router = (0,next_router.useRouter)();
  var carryOverQuery = extractCarryOverQueryFromCurrentUrl(router.query);
  var bookingFlowEnterPath = "/".concat(nickname, "/").concat(public_id, "/book");
  var contactPageHref = contactUrl || "/".concat(nickname, "/contact?via=").concat(public_id);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
    className: classes,
    children: isBookable ? /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      href: {
        pathname: bookingFlowEnterPath,
        query: carryOverQuery
      },
      prefetch: false,
      passHref: true,
      legacyBehavior: true,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.ZP, {
        className_Deprecated: (MerchantCourseDetailsReservationButton_module_default()).MerchantCourseDetailsReservationButton__Button,
        children: intl.formatMessage({
          id: 'merchants.bookingPages.reservation'
        })
      })
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      href: contactPageHref,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.ZP, {
        href: contactPageHref,
        className_Deprecated: (MerchantCourseDetailsReservationButton_module_default()).MerchantCourseDetailsReservationButton__Button,
        children: intl.formatMessage({
          id: 'merchants.bookingPages.inquiry'
        })
      })
    })
  });
};

var extractCarryOverQueryFromCurrentUrl = function extractCarryOverQueryFromCurrentUrl(query) {
  var extracted = {};

  var extract = function extract(key) {
    var q = query[key];

    if (typeof q === 'string') {
      extracted[key] = q;
    }
  };

  extract('selected_staff');
  extract('selected_course');
  extract('selected_lesson');
  extract('selected_slot');
  extract('selected_date');
  return extracted;
};

/* harmony default export */ var book_MerchantCourseDetailsReservationButton = (MerchantCourseDetailsReservationButton);
// EXTERNAL MODULE: ./src/templates/merchants/resources/DetailTemplate/components/MerchantCourseDetailsHeader/MerchantCourseDetailsHeader.module.scss
var MerchantCourseDetailsHeader_module = __webpack_require__(11901);
var MerchantCourseDetailsHeader_module_default = /*#__PURE__*/__webpack_require__.n(MerchantCourseDetailsHeader_module);
// EXTERNAL MODULE: ./src/reservation-page/RSButtonLink/index.tsx + 1 modules
var RSButtonLink = __webpack_require__(2244);
// EXTERNAL MODULE: ./src/reservation-page/icons/kantan-icon.svg
var kantan_icon = __webpack_require__(40965);
// EXTERNAL MODULE: ./src/hooks/api/me/index.ts + 2 modules
var me = __webpack_require__(21966);
// EXTERNAL MODULE: ./src/reservation-page/RSKantanIconButtonAnchor/index.tsx
var RSKantanIconButtonAnchor = __webpack_require__(42181);
;// CONCATENATED MODULE: ./src/templates/merchants/resources/DetailTemplate/components/MerchantCourseDetailsHeader/index.tsx


function MerchantCourseDetailsHeader_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function MerchantCourseDetailsHeader_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? MerchantCourseDetailsHeader_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : MerchantCourseDetailsHeader_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


















var MerchantCourseDetailsHeader = function MerchantCourseDetailsHeader(props) {
  var merchantSetting = props.merchantSetting,
      isFullyBooked = props.isFullyBooked,
      name = props.name,
      tag_names = props.tag_names,
      rate_count = props.rate_count,
      rate = props.rate,
      lowest_price = props.lowest_price,
      unique_pricing = props.unique_pricing,
      optIn = props.optIn,
      isEvent = props.isEvent,
      merchant_public_id = props.merchant_public_id,
      resource_public_id = props.public_id,
      isRequireCustomerLogin = props.isRequireCustomerLogin;
  var classes = classnames_default()((MerchantCourseDetailsHeader_module_default()).MerchantCourseDetailsHeader);
  var intl = (0,useIntl/* default */.Z)();

  var _useUserMe = (0,me/* useUserMe */.J1)(),
      user = _useUserMe.user;

  var router = (0,next_router.useRouter)();
  var M3ReservationFlowQuery = react.useMemo(function () {
    var query = new URLSearchParams();
    router.query.selected_slot && query.set('timeSlotId', router.query.selected_slot);
    return query.toString();
  }, [router.query.selected_slot]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: classes,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (MerchantCourseDetailsHeader_module_default()).MerchantCourseDetailsHeader__Inner,
      children: [tag_names.map(function (tag, i) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(MerchantTag/* default */.Z, {
          status: tag
        }, i);
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (MerchantCourseDetailsHeader_module_default()).MerchantCourseDetailsHeader__Header,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
          className: (MerchantCourseDetailsHeader_module_default()).MerchantCourseDetailsHeader__Title,
          children: name
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (MerchantCourseDetailsHeader_module_default()).MerchantCourseDetailsHeader__SummaryContainer,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (MerchantCourseDetailsHeader_module_default()).MerchantCourseDetailsHeader__Summary,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              children: merchantSetting.is_customer_review_active && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StarRating/* default */.Z, {
                  className: (MerchantCourseDetailsHeader_module_default()).MerchantCourseDetailsHeader__StarRating,
                  rate: rate || 0
                }), rate_count > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: (MerchantCourseDetailsHeader_module_default()).MerchantCourseDetailsHeader__ReviewCount,
                  children: "(".concat(rate_count, ")")
                })]
              })
            }), lowest_price !== undefined && !optIn.reservationFlow.m3 && /*#__PURE__*/(0,jsx_runtime.jsx)(LowestPrice/* default */.Z, {
              className: (MerchantCourseDetailsHeader_module_default()).MerchantCourseDetailsHeader__Price,
              lowestPrice: lowest_price,
              uniquePricing: unique_pricing
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (MerchantCourseDetailsHeader_module_default()).MerchantCourseDetailsHeader__ButtonContainer,
            children: optIn.reservationFlow.m3 && isEvent ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "hidden legacyPc:block",
              children: user ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "w-[200px]",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(RSButtonLink/* RSButtonLink */.g, {
                  isBlock: true,
                  href: "/".concat(merchant_public_id, "/").concat(resource_public_id, "/book/event_type"),
                  children: "\u4E88\u7D04"
                })
              }) : /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "flex gap-1.5",
                children: [!isRequireCustomerLogin && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "w-[200px]",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(RSButtonLink/* RSButtonLink */.g, {
                    isBlock: true,
                    href: "/".concat(merchant_public_id, "/").concat(resource_public_id, "/book/event_type?").concat(M3ReservationFlowQuery),
                    children: "\u30B2\u30B9\u30C8\u4E88\u7D04"
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "w-[200px]",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(RSKantanIconButtonAnchor/* RSKantanIconButtonAnchor */.I, {
                    icon: /*#__PURE__*/(0,jsx_runtime.jsx)(kantan_icon/* default */.Z, {
                      width: "24",
                      height: "24",
                      viewBox: "0 0 24 24"
                    }),
                    isBlock: true,
                    href: "/signin/user?return_to=/".concat(merchant_public_id, "/").concat(resource_public_id, "/book/event_type?").concat(M3ReservationFlowQuery),
                    variant: "black",
                    children: "\u30ED\u30B0\u30A4\u30F3\u3057\u3066\u4E88\u7D04"
                  })
                })]
              })
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)(book_MerchantCourseDetailsReservationButton, MerchantCourseDetailsHeader_objectSpread({
              contactUrl: merchantSetting.contact_url
            }, props))
          })]
        })]
      }), isFullyBooked && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: (MerchantCourseDetailsHeader_module_default()).MerchantCourseDetailsHeader__Notice,
        children: intl.formatMessage({
          id: 'merchants.bookingPages.notice.fullyBooked'
        })
      })]
    })
  });
};

/* harmony default export */ var components_MerchantCourseDetailsHeader = (MerchantCourseDetailsHeader);
// EXTERNAL MODULE: ./src/templates/merchants/resources/DetailTemplate/components/MerchantCourseDetailsHeaderImage/MerchantCourseDetailsHeaderImage.module.scss
var MerchantCourseDetailsHeaderImage_module = __webpack_require__(55960);
var MerchantCourseDetailsHeaderImage_module_default = /*#__PURE__*/__webpack_require__.n(MerchantCourseDetailsHeaderImage_module);
;// CONCATENATED MODULE: ./src/templates/merchants/resources/DetailTemplate/components/MerchantCourseDetailsHeaderImage/index.tsx






var MerchantCourseDetailsHeaderImage_MerchantCourseDetailsHeader = function MerchantCourseDetailsHeader(props) {
  var _classNames;

  var name = props.name,
      _props$primary_image = props.primary_image,
      _props$primary_image$ = _props$primary_image.meta,
      width = _props$primary_image$.width,
      height = _props$primary_image$.height,
      p800x600 = _props$primary_image.p800x600,
      p1280x1280 = _props$primary_image.p1280x1280;
  var classes = classnames_default()((MerchantCourseDetailsHeaderImage_module_default()).MerchantCourseDetailsHeaderImage, (_classNames = {}, (0,defineProperty/* default */.Z)(_classNames, (MerchantCourseDetailsHeaderImage_module_default()).isLargePortrait, width >= 640 && height > width), (0,defineProperty/* default */.Z)(_classNames, (MerchantCourseDetailsHeaderImage_module_default()).isMiddle, width < 640 && width >= 400), (0,defineProperty/* default */.Z)(_classNames, (MerchantCourseDetailsHeaderImage_module_default()).isSmall, width < 400 && width >= 200), (0,defineProperty/* default */.Z)(_classNames, (MerchantCourseDetailsHeaderImage_module_default()).isTiny, width < 200), _classNames));
  var srcUrl = width <= 800 ? p800x600.url : p1280x1280.url;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
    className: classes,
    src: srcUrl,
    alt: name
  });
};

/* harmony default export */ var MerchantCourseDetailsHeaderImage = (MerchantCourseDetailsHeaderImage_MerchantCourseDetailsHeader);
// EXTERNAL MODULE: ./src/molecules/merchant/resources/book/MerchantCourseDetailsStaffList/index.tsx
var MerchantCourseDetailsStaffList = __webpack_require__(42839);
;// CONCATENATED MODULE: ./src/organisms/merchants/MerchantStickyFooter/index.tsx









var MerchantStickyFooter = function MerchantStickyFooter(_ref) {
  var merchant_public_id = _ref.merchant_public_id,
      resource_public_id = _ref.resource_public_id,
      isRequireCustomerLogin = _ref.isRequireCustomerLogin;

  var _useUserMe = (0,me/* useUserMe */.J1)(),
      user = _useUserMe.user;

  var router = (0,next_router.useRouter)();
  var M3ReservationFlowQuery = (0,react.useMemo)(function () {
    var query = new URLSearchParams();
    router.query.selected_slot && query.set('timeSlotId', router.query.selected_slot);
    return query.toString();
  }, [router.query.selected_slot]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "sticky bottom-0 block  border-0 border-t border-solid border-gray-50 bg-white px-[20px] py-2 legacyPc:hidden",
    children: user ? /*#__PURE__*/(0,jsx_runtime.jsx)(RSButtonLink/* RSButtonLink */.g, {
      isBlock: true,
      href: "/".concat(merchant_public_id, "/").concat(resource_public_id, "/book/event_type"),
      children: "\u4E88\u7D04"
    }) : /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "flex flex-col gap-1.5",
      children: [!isRequireCustomerLogin && /*#__PURE__*/(0,jsx_runtime.jsx)(RSButtonLink/* RSButtonLink */.g, {
        isBlock: true,
        href: "/".concat(merchant_public_id, "/").concat(resource_public_id, "/book/event_type?").concat(M3ReservationFlowQuery),
        children: "\u30B2\u30B9\u30C8\u4E88\u7D04"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(RSKantanIconButtonAnchor/* RSKantanIconButtonAnchor */.I, {
        icon: /*#__PURE__*/(0,jsx_runtime.jsx)(kantan_icon/* default */.Z, {
          width: "24",
          height: "24",
          viewBox: "0 0 24 24"
        }),
        isBlock: true,
        href: "/signin/user?return_to=/".concat(merchant_public_id, "/").concat(resource_public_id, "/book/event_type?").concat(M3ReservationFlowQuery),
        variant: "black",
        children: "\u30ED\u30B0\u30A4\u30F3\u3057\u3066\u4E88\u7D04"
      })]
    })
  });
};

/* harmony default export */ var merchants_MerchantStickyFooter = (MerchantStickyFooter);
;// CONCATENATED MODULE: ./src/templates/merchants/resources/DetailTemplate/MerchantBookingServiceShowPage.tsx


var MerchantBookingServiceShowPage_excluded = ["cover_content", "cover_contents_type", "description", "description_text", "primary_image", "is_json_description", "require_customer_login"];

function MerchantBookingServiceShowPage_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function MerchantBookingServiceShowPage_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? MerchantBookingServiceShowPage_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : MerchantBookingServiceShowPage_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }































var MAX_REVIEWS = 3;
var mapPhotoGalleryImageToLightbox = function mapPhotoGalleryImageToLightbox(images) {
  var lightboxImages = images.map(function (image, i) {
    return {
      thumbUrl: findThumb(image),
      mainUrl: findImage(image),
      id: i
    };
  }).filter(function (image) {
    return image.mainUrl !== '' && image.thumbUrl !== '';
  });
  return lightboxImages;
};

var MerchantbookingPageShowPage = function MerchantbookingPageShowPage(_ref) {
  var bookingData = _ref.bookingData,
      isBookable = _ref.isBookable,
      settings = _ref.settings,
      merchantDetail = _ref.merchantDetail,
      courses = _ref.courses,
      staff = _ref.staff,
      reviews = _ref.reviews,
      isCoubicApp = _ref.isCoubicApp,
      optIn = _ref.optIn;
  var intl = (0,useIntl/* default */.Z)();

  var _useUserMe = (0,me/* useUserMe */.J1)(),
      user = _useUserMe.user;

  var canShowReviews = merchantDetail.merchant_setting.is_customer_review_active && merchantDetail.rate_count_starby && reviews && reviews.length > 0;

  var cover_content = bookingData.cover_content,
      cover_contents_type = bookingData.cover_contents_type,
      description = bookingData.description,
      description_text = bookingData.description_text,
      primary_image = bookingData.primary_image,
      is_json_description = bookingData.is_json_description,
      require_customer_login = bookingData.require_customer_login,
      headerProps = (0,objectWithoutProperties/* default */.Z)(bookingData, MerchantBookingServiceShowPage_excluded);

  var notes = (0,helper/* useResourceNotes */.dc)(settings);
  var isEvent = bookingData.model_type === BookingPage/* BookingPageScheme.Event */.q0.Event;
  var isFullyBooked = bookingData.status === bookings/* MerchantBookingStatus.FullyBooked */._z.FullyBooked; // explore掲載専用マーチャントの場合、予約に関しての注意事項が紛らわしいので見せない。(予約導線はクービック内に無い為)

  var attentionForBookingVisible = !merchantDetail.merchant_setting.is_explore_only;
  var router = (0,next_router.useRouter)();
  var M3ReservationFlowQuery = react.useMemo(function () {
    var query = new URLSearchParams();
    router.query.selected_slot && query.set('timeSlotId', router.query.selected_slot);
    return query.toString();
  }, [router.query.selected_slot]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BaseTemplate/* default */.Z, {
      merchantDetail: merchantDetail,
      bookingPageIsBookable: isBookable,
      isCoubicApp: isCoubicApp,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (MerchantBookingServiceShowPage_module_default()).MerchantBookingServiceShowPage,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (MerchantBookingServiceShowPage_module_default()).MerchantBookingServiceShowPage__Heading,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_MerchantCourseDetailsHeader, MerchantBookingServiceShowPage_objectSpread({
            isRequireCustomerLogin: require_customer_login,
            isBookable: isBookable,
            merchantSetting: merchantDetail.merchant_setting,
            isEvent: isEvent,
            isFullyBooked: isFullyBooked,
            optIn: optIn,
            merchant_public_id: merchantDetail.public_id
          }, headerProps))
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (MerchantBookingServiceShowPage_module_default()).MerchantBookingServiceShowPage__HeroImage,
          children: [cover_contents_type === 'upload_image' && primary_image && /*#__PURE__*/(0,jsx_runtime.jsx)(MerchantCourseDetailsHeaderImage, {
            name: headerProps.name,
            primary_image: primary_image
          }), cover_contents_type === 'embed' && cover_content && cover_content.embed && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (MerchantBookingServiceShowPage_module_default()).MerchantBookingServiceShowPage__Embed,
            dangerouslySetInnerHTML: {
              __html: cover_content.embed
            }
          })]
        }), (is_json_description && description || description_text) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (MerchantBookingServiceShowPage_module_default()).MerchantBookingServiceShowPage__Section,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(DescriptionPanel/* default */.Z, {
            description: description,
            description_text: description_text,
            is_json_description: is_json_description
          })
        }), isBookable && courses.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (MerchantBookingServiceShowPage_module_default()).MerchantBookingServiceShowPage__Section,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* default */.Z, {
            className: (MerchantBookingServiceShowPage_module_default()).MerchantBookingServiceShowPage__Heading,
            children: intl.formatMessage({
              id: 'books.formsLabel.appointment'
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_Appointment, {
            nickname: merchantDetail.public_id,
            resourceId: bookingData.public_id,
            courses: courses,
            staff: staff
          })]
        }), isEvent && staff.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (MerchantBookingServiceShowPage_module_default()).MerchantBookingServiceShowPage__Section,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* default */.Z, {
            className: (MerchantBookingServiceShowPage_module_default()).MerchantBookingServiceShowPage__Heading,
            children: intl.formatMessage({
              id: 'books.formsLabel.staff'
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(MerchantCourseDetailsStaffList/* default */.Z, {
            staff: staff
          })]
        }), attentionForBookingVisible && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (MerchantBookingServiceShowPage_module_default()).MerchantBookingServiceShowPage__Section,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* default */.Z, {
            className: (MerchantBookingServiceShowPage_module_default()).MerchantBookingServiceShowPage__Heading,
            children: intl.formatMessage({
              id: 'books.formsLabel.attentionForBooking'
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(BooksNotes/* default */.Z, {
            notes: notes
          }), optIn.reservationFlow.m3 && isEvent ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "hidden justify-end pt-2 legacyPc:flex",
            children: user ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "w-[200px]",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(RSButtonLink/* RSButtonLink */.g, {
                isBlock: true,
                href: "/".concat(merchantDetail.public_id, "/").concat(bookingData.public_id, "/book/event_type?").concat(M3ReservationFlowQuery),
                children: "\u4E88\u7D04"
              })
            }) : /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "flex gap-1.5",
              children: [!require_customer_login && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "w-[200px]",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(RSButtonLink/* RSButtonLink */.g, {
                  isBlock: true,
                  href: "/".concat(merchantDetail.public_id, "/").concat(bookingData.public_id, "/book/event_type?").concat(M3ReservationFlowQuery),
                  children: "\u30B2\u30B9\u30C8\u4E88\u7D04"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "w-[200px]",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(RSKantanIconButtonAnchor/* RSKantanIconButtonAnchor */.I, {
                  icon: /*#__PURE__*/(0,jsx_runtime.jsx)(kantan_icon/* default */.Z, {
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24"
                  }),
                  isBlock: true,
                  href: "/signin/user?return_to=/".concat(merchantDetail.public_id, "/").concat(bookingData.public_id, "/book/event_type"),
                  variant: "black",
                  children: "\u30ED\u30B0\u30A4\u30F3\u3057\u3066\u4E88\u7D04"
                })
              })]
            })
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: (MerchantBookingServiceShowPage_module_default()).MerchantBookingServiceShowPage__ButtonContainer,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(book_MerchantCourseDetailsReservationButton, MerchantBookingServiceShowPage_objectSpread({
              isBookable: isBookable,
              contactUrl: merchantDetail.merchant_setting.contact_url
            }, bookingData))
          })]
        }), bookingData.map_widget && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (MerchantBookingServiceShowPage_module_default()).MerchantBookingServiceShowPage__Section,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* default */.Z, {
            className: (MerchantBookingServiceShowPage_module_default()).MerchantBookingServiceShowPage__Heading,
            children: intl.formatMessage({
              id: 'merchants.details.access'
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(common_GoogleMap, {
            displayName: merchantDetail.display_name,
            mapData: bookingData.map_widget
          })]
        }), bookingData.photo_gallery_images.length >= 1 && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (MerchantBookingServiceShowPage_module_default()).MerchantBookingServiceShowPage__Section,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* default */.Z, {
            className: (MerchantBookingServiceShowPage_module_default()).MerchantBookingServiceShowPage__Heading,
            children: intl.formatMessage({
              id: 'merchants.bookingPages.photoGallery'
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Lightbox/* default */.Z, {
            images: mapPhotoGalleryImageToLightbox(bookingData.photo_gallery_images),
            alt: bookingData.name
          })]
        }), canShowReviews && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (MerchantBookingServiceShowPage_module_default()).MerchantBookingServiceShowPage__Section,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* default */.Z, {
            className: (MerchantBookingServiceShowPage_module_default()).MerchantBookingServiceShowPage__Heading,
            children: intl.formatMessage({
              id: 'reviews.title'
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(ReviewList/* default */.Z, {
            reviews: reviews,
            merchantDetail: merchantDetail,
            max: MAX_REVIEWS,
            rate_count_starby: merchantDetail.rate_count_starby,
            showHeader: true
          }), reviews.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: "/".concat(merchantDetail.public_id, "/reviews"),
            prefetch: false,
            className: (MerchantBookingServiceShowPage_module_default()).MerchantBookingServiceShowPage__ReviewLink,
            children: intl.formatMessage({
              id: 'merchants.details.showMoreReviews'
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (MerchantBookingServiceShowPage_module_default()).MerchantBookingServiceShowPage__Section,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* default */.Z, {
            className: (MerchantBookingServiceShowPage_module_default()).MerchantBookingServiceShowPage__Heading,
            children: intl.formatMessage({
              id: 'merchants.bookingPages.storeData'
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(MerchantProfile/* default */.Z, {
            merchantDetail: merchantDetail
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (MerchantBookingServiceShowPage_module_default()).MerchantBookingServiceShowPage__BackToTopButtonSection,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.ZP, {
              className_Deprecated: (MerchantBookingServiceShowPage_module_default()).MerchantBookingServiceShowPage__BackToTopButton,
              isGhost: true,
              isFull: true,
              href: "/".concat(merchantDetail.public_id),
              buttonSize: Button/* ButtonSize.Medium */.qE.Medium,
              children: intl.formatMessage({
                id: 'merchants.details.backToMerchantTop'
              }, {
                displayName: merchantDetail.display_name
              })
            })
          })]
        })]
      })
    }), optIn.reservationFlow.m3 && isEvent && /*#__PURE__*/(0,jsx_runtime.jsx)(merchants_MerchantStickyFooter, {
      merchant_public_id: merchantDetail.public_id,
      resource_public_id: bookingData.public_id,
      isRequireCustomerLogin: require_customer_login
    })]
  });
}; //  findThumb is helper


function findThumb(data) {
  if (data.image.thumb && data.image.thumb.url) {
    return data.image.thumb.url || '';
  }

  if (data.image.square && data.image.square.url) {
    return data.image.square.url || '';
  }

  if (data.image.p800x600 && data.image.p800x600.url) {
    return data.image.p800x600.url || '';
  }

  if (data.image.p1280x1280 && data.image.p1280x1280.url) {
    return data.image.p1280x1280.url || '';
  }

  if (data.image && data.image.url) {
    return data.image.url || '';
  }

  return '';
} //  findImage is helper


function findImage(image) {
  if (image.image.p1280x1280 && image.image.p1280x1280.url) {
    return image.image.p1280x1280.url || '';
  }

  if (image.image.p800x600 && image.image.p800x600.url) {
    return image.image.p800x600.url || '';
  }

  if (image.image && image.image.url) {
    return image.image.url || '';
  }

  if (image.image.square && image.image.square.url) {
    return image.image.square.url || '';
  }

  if (image.image.thumb && image.image.thumb.url) {
    return image.image.thumb.url || '';
  }

  return '';
}

/* harmony default export */ var MerchantBookingServiceShowPage = (MerchantbookingPageShowPage);
// EXTERNAL MODULE: ./src/molecules/merchant/resources/book/MerchantCourseDetailsPageProtected/index.tsx
var MerchantCourseDetailsPageProtected = __webpack_require__(15572);
// EXTERNAL MODULE: ./src/templates/ErrorTemplate/index.tsx + 5 modules
var ErrorTemplate = __webpack_require__(37602);
// EXTERNAL MODULE: ./src/infrastructure/api/backend/explore_api.ts + 1 modules
var explore_api = __webpack_require__(72314);
// EXTERNAL MODULE: ./src/infrastructure/repositories/BookingPageRepository.ts
var BookingPageRepository = __webpack_require__(67988);
// EXTERNAL MODULE: ./src/redux/reducers/merchants/resources/books/helper.ts + 1 modules
var books_helper = __webpack_require__(83929);
// EXTERNAL MODULE: ./src/infrastructure/api/index.ts
var api = __webpack_require__(39851);
// EXTERNAL MODULE: ./src/utils/sanitizeResourcePublicId.ts
var sanitizeResourcePublicId = __webpack_require__(29832);
// EXTERNAL MODULE: ./src/hooks/gtm/index.ts
var gtm = __webpack_require__(51295);
// EXTERNAL MODULE: ./src/openapi/axiosClient.ts + 1 modules
var axiosClient = __webpack_require__(39428);
// EXTERNAL MODULE: ./src/utils/metatag.ts
var metatag = __webpack_require__(10767);
;// CONCATENATED MODULE: ./src/pages/[publicId]/[resource_id]/index.tsx




function _resource_id_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _resource_id_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? _resource_id_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : _resource_id_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






















var MerchantResourceComponent = function MerchantResourceComponent(props) {
  var _state$merchantDetail;

  var state = props.state,
      isBookable = props.isBookable;
  (0,gtm/* usePushMerchantDataLayerEffect */.O)({
    visit_merchant_id: state === null || state === void 0 ? void 0 : (_state$merchantDetail = state.merchantDetail) === null || _state$merchantDetail === void 0 ? void 0 : _state$merchantDetail.id
  });

  if (!state) {
    return null;
  }

  var merchantDetail = state.merchantDetail,
      category = state.category,
      reviews = state.reviews,
      bookingData = state.bookingData,
      settings = state.settings,
      courses = state.courses,
      staff = state.staff,
      optIn = state.optIn;

  if (merchantDetail && category && reviews) {
    var _merchantDetail$seo_s, _merchantDetail$seo_s2, _merchantDetail$favic;

    return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(MetaTags/* default */.Z, {
        title: state.bookingData.name,
        description: state.bookingData.description_text,
        keywords: ((_merchantDetail$seo_s = merchantDetail.seo_setting) === null || _merchantDetail$seo_s === void 0 ? void 0 : _merchantDetail$seo_s.keyword) || '',
        thumbnailUrl: (0,metatag/* toThumbnailUrl */.x)({
          merchantDetail: merchantDetail,
          bookingData: state.bookingData
        }),
        currentUrl: "".concat(MetaTags/* COUBIC_ORIGIN */._, "/").concat(merchantDetail.public_id, "/").concat(state.bookingData.public_id),
        noIndex: (_merchantDetail$seo_s2 = merchantDetail.seo_setting) === null || _merchantDetail$seo_s2 === void 0 ? void 0 : _merchantDetail$seo_s2.no_index,
        googleAnalyticsFourTrackingId: merchantDetail.available_google_analytics_four_tracking_id,
        faviconImageUrl: merchantDetail === null || merchantDetail === void 0 ? void 0 : (_merchantDetail$favic = merchantDetail.favicon_image) === null || _merchantDetail$favic === void 0 ? void 0 : _merchantDetail$favic.url
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(JsonLd/* default */.Z, {
        bookingData: bookingData,
        merchant: merchantDetail,
        reviews: reviews
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(MerchantBookingServiceShowPage, {
        bookingData: bookingData,
        isBookable: isBookable,
        reviews: reviews,
        settings: settings,
        merchantDetail: merchantDetail,
        courses: courses,
        staff: staff,
        isCoubicApp: props.isCoubicApp,
        optIn: optIn
      })]
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorTemplate/* default */.Z, {
    statusCode: 404
  });
};

var MerchantResource = function MerchantResource(props) {
  var _state$merchantDetail2, _state$merchantDetail3, _state$merchantDetail4;

  var session = props.session,
      token = props.token,
      requestId = props.requestId,
      isPasswordProtected = props.isPasswordProtected,
      isBookable = props.isBookable,
      isUnpublishedSite = props.isUnpublishedSite,
      resourcePublicId = props.resourcePublicId,
      merchantPublicId = props.merchantPublicId,
      pageProps = props.pageProps,
      isCoubicApp = props.isCoubicApp;

  var _useState = (0,react.useState)(isPasswordProtected),
      passwordProtected = _useState[0],
      setPasswordProtected = _useState[1];

  var _useState2 = (0,react.useState)(pageProps),
      state = _useState2[0],
      setState = _useState2[1];

  var onPasswordSubmit = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(success) {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!success) {
                _context.next = 7;
                break;
              }

              setPasswordProtected(false); // FIXME: ここちゃんとrouter使ってページ遷移させるべき

              _context.t0 = setState;
              _context.next = 5;
              return fetchPageProps({
                session: session,
                token: token,
                requestId: requestId,
                resourcePublicId: resourcePublicId,
                merchantPublicId: merchantPublicId
              });

            case 5:
              _context.t1 = _context.sent;
              (0, _context.t0)(_context.t1);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onPasswordSubmit(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsx)(MerchantSite/* MerchantSite */.Z, {
    isProtected: passwordProtected,
    protectedElement: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(MetaTags/* default */.Z, {
        noIndex: true,
        opgDisabled: true,
        googleAnalyticsFourTrackingId: state === null || state === void 0 ? void 0 : (_state$merchantDetail2 = state.merchantDetail) === null || _state$merchantDetail2 === void 0 ? void 0 : _state$merchantDetail2.available_google_analytics_four_tracking_id
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(MerchantCourseDetailsPageProtected/* default */.Z, {
        publicId: merchantPublicId,
        servicePublicId: resourcePublicId,
        onSubmit: onPasswordSubmit,
        session: session,
        token: token,
        requestId: requestId
      })]
    }),
    isUnPublished: isUnpublishedSite !== null && isUnpublishedSite !== void 0 ? isUnpublishedSite : false,
    isMerchantInfoExist: !!(state !== null && state !== void 0 && state.merchantDetail),
    logoImage: (state === null || state === void 0 ? void 0 : (_state$merchantDetail3 = state.merchantDetail) === null || _state$merchantDetail3 === void 0 ? void 0 : _state$merchantDetail3.logo_image) || null,
    merchantPublicId: merchantPublicId,
    displayName: (state === null || state === void 0 ? void 0 : (_state$merchantDetail4 = state.merchantDetail) === null || _state$merchantDetail4 === void 0 ? void 0 : _state$merchantDetail4.display_name) || null,
    isCoubicApp: isCoubicApp,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(MerchantResourceComponent, {
      state: state,
      isBookable: isBookable,
      isCoubicApp: isCoubicApp
    })
  });
};

var fetchPageProps = /*#__PURE__*/function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(args) {
    var _m3OptIn$opt_in;

    var session, token, requestId, resourcePublicId, merchantPublicId, repository, sanitizedResourcePublicId, client, _yield$Promise$all$ca, _yield$Promise$all$ca2, merchantDetailResponse, categories, bookingData, settings, review, m3OptIn, merchant, category, pageProps, courses, staff;

    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            session = args.session, token = args.token, requestId = args.requestId, resourcePublicId = args.resourcePublicId, merchantPublicId = args.merchantPublicId;
            repository = (0,BookingPageRepository/* BookingPageRepositoryForSSR */.SC)(session, token, requestId);
            sanitizedResourcePublicId = (0,sanitizeResourcePublicId/* sanitizeResourcePublicId */.k)(resourcePublicId);
            client = (0,axiosClient/* getApiClient */.sT)();
            _context2.next = 6;
            return Promise.all([// Layoutで取得している部分を徐々に置き換え中
            (0,api/* fetchMerchantDetail */.uY)({
              session: session,
              token: token,
              requestId: requestId,
              merchantPublicId: merchantPublicId
            }), (0,explore_api/* allCategoriesCache */.Cp)(), // axios.getだとcookieが載らないので、BookingPageRepositoryForSSR経由で取得
            repository.Find(merchantPublicId, sanitizedResourcePublicId), repository.ConfirmData(merchantPublicId, sanitizedResourcePublicId), (0,api/* fetchMerchantReviewsForSSR */._x)({
              session: session,
              token: token,
              requestId: requestId,
              merchantPublicId: merchantPublicId,
              page: 1,
              perPage: 10
            }), client.getReservationFlowEventSchemeMerchantOptIn({
              parameter: {
                merchant_public_id: merchantPublicId
              }
            })])["catch"](function (err) {
              throw err;
            });

          case 6:
            _yield$Promise$all$ca = _context2.sent;
            _yield$Promise$all$ca2 = (0,slicedToArray/* default */.Z)(_yield$Promise$all$ca, 6);
            merchantDetailResponse = _yield$Promise$all$ca2[0];
            categories = _yield$Promise$all$ca2[1];
            bookingData = _yield$Promise$all$ca2[2];
            settings = _yield$Promise$all$ca2[3];
            review = _yield$Promise$all$ca2[4];
            m3OptIn = _yield$Promise$all$ca2[5];
            merchant = merchantDetailResponse.merchant;

            if (!merchant) {
              _context2.next = 21;
              break;
            }

            _context2.next = 18;
            return (0,explore_api/* getCategory */.n3)(merchant.category_id);

          case 18:
            _context2.t0 = _context2.sent;
            _context2.next = 22;
            break;

          case 21:
            _context2.t0 = undefined;

          case 22:
            category = _context2.t0;
            pageProps = {
              merchantDetail: merchant,
              category: category,
              categories: categories,
              bookingData: bookingData,
              settings: (0,books_helper/* toSettingConfirm */.fi)(settings),
              reviews: review === null || review === void 0 ? void 0 : review.data,
              courses: [],
              staff: [],
              isBookable: false,
              optIn: {
                reservationFlow: {
                  m3: (_m3OptIn$opt_in = m3OptIn === null || m3OptIn === void 0 ? void 0 : m3OptIn.opt_in) !== null && _m3OptIn$opt_in !== void 0 ? _m3OptIn$opt_in : false
                }
              }
            }; // FIXME: 本当はV2側でisStaffSelectableを考慮したほうがいいかもしれないが他に影響出るかもなのでここでハンドリングする

            if (!(pageProps.bookingData.model_type === bookings/* BookingPageScheme.ASSIGN */.q0.ASSIGN || pageProps.bookingData.model_type === bookings/* BookingPageScheme.AVAILABILITY */.q0.AVAILABILITY)) {
              _context2.next = 29;
              break;
            }

            _context2.next = 27;
            return repository.SearchCourse(merchantPublicId, sanitizedResourcePublicId);

          case 27:
            courses = _context2.sent;
            pageProps = _resource_id_objectSpread(_resource_id_objectSpread({}, pageProps), {}, {
              courses: courses.data
            });

          case 29:
            if (!(pageProps.bookingData.model_type === bookings/* BookingPageScheme.ASSIGN */.q0.ASSIGN && pageProps.bookingData.staff_selectable || pageProps.bookingData.model_type === bookings/* BookingPageScheme.EVENT */.q0.EVENT)) {
              _context2.next = 34;
              break;
            }

            _context2.next = 32;
            return repository.SearchStaff(merchantPublicId, sanitizedResourcePublicId);

          case 32:
            staff = _context2.sent;
            pageProps = _resource_id_objectSpread(_resource_id_objectSpread({}, pageProps), {}, {
              staff: staff.data
            });

          case 34:
            return _context2.abrupt("return", _resource_id_objectSpread({}, pageProps));

          case 35:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function fetchPageProps(_x2) {
    return _ref2.apply(this, arguments);
  };
}();

var __N_SSP = true;
/* harmony default export */ var _resource_id_ = (MerchantResource);

/***/ }),

/***/ 2244:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "g": function() { return /* binding */ RSButtonLink; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(77521);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./node_modules/@react-aria/focus/dist/module.js + 2 modules
var dist_module = __webpack_require__(35044);
// EXTERNAL MODULE: ./node_modules/@react-aria/utils/dist/module.js
var utils_dist_module = __webpack_require__(83952);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/reservation-page/RSButtonAnchor/index.module.css
var index_module = __webpack_require__(82011);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/reservation-page/RSButtonAnchor/index.tsx


var _excluded = ["variant", "isBlock", "isDisabled", "children"];


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var RSButtonAnchor = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'basic' : _ref$variant,
      _ref$isBlock = _ref.isBlock,
      isBlock = _ref$isBlock === void 0 ? false : _ref$isBlock,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      children = _ref.children,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var _useFocusRing = (0,dist_module/* useFocusRing */.Fx)(),
      isFocusVisible = _useFocusRing.isFocusVisible,
      focusProps = _useFocusRing.focusProps;

  var color = '#0066FF';
  var wrapperHeightClasses = (0,react.useMemo)(function () {
    switch (variant) {
      case 'large':
        return ['h-56'];

      case 'basic':
      case 'outline':
      case 'destructive':
        return ['h-48', 'pc:h-44'];
    }
  }, [variant]);
  var buttonSizeClasses = (0,react.useMemo)(function () {
    switch (variant) {
      case 'large':
        return ['px-[20px]'];

      case 'basic':
      case 'outline':
      case 'destructive':
        return ['px-2'];
    }
  }, [variant]);
  var buttonColorClasses = (0,react.useMemo)(function () {
    switch (variant) {
      case 'large':
        return [isDisabled && 'bg-gray-10', !isDisabled ? 'text-white' : 'text-gray-200', isDisabled && 'border-gray-10'];

      case 'basic':
        return [isDisabled && 'bg-gray-10', !isDisabled ? 'text-white' : 'text-gray-200', isDisabled && 'border-gray-10'];

      case 'outline':
        return [!isDisabled ? 'bg-white' : 'bg-gray-10', isDisabled && 'text-gray-200', !isDisabled ? 'border-gray-200' : 'border-gray-10'];

      case 'destructive':
        return [!isDisabled ? 'bg-white' : 'bg-gray-10', !isDisabled ? 'text-red-700' : 'text-gray-200', !isDisabled ? 'border-gray-200' : 'border-gray-10'];
    }
  }, [variant, isDisabled]);
  var isButtonBackgroundColorPrimary = (0,react.useMemo)(function () {
    if (isDisabled) {
      return false;
    }

    if (variant !== 'large' && variant !== 'basic') {
      return false;
    }

    return true;
  }, [variant, isDisabled]);
  var isButtonTextColorPrimary = (0,react.useMemo)(function () {
    if (isDisabled) {
      return false;
    }

    if (variant !== 'outline') {
      return false;
    }

    return true;
  }, [variant, isDisabled]);
  var isButtonBorderColorPrimary = (0,react.useMemo)(function () {
    if (isDisabled) {
      return false;
    }

    if (variant !== 'large' && variant !== 'basic') {
      return false;
    }

    return true;
  }, [variant, isDisabled]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "jsx-3362828503" + " " + (classnames_default()('wrapper', isFocusVisible && 'focus-visible', !isBlock ? 'inline-block' : ['block', 'w-full'], 'relative', wrapperHeightClasses, 'rounded-15', 'after:transition', // cursor-event-noneとcursor-not-allowedを同じ要素で利用できないため
      !isDisabled ? 'cursor-pointer' : 'cursor-not-allowed') || ""),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", _objectSpread(_objectSpread({}, (0,utils_dist_module/* mergeProps */.dG)(props, focusProps)), {}, {
        ref: ref,
        tabIndex: !isDisabled ? undefined : -1,
        className: "jsx-3362828503" + " " + (classnames_default()('button', isButtonBackgroundColorPrimary && 'bg-primary', isButtonTextColorPrimary && 'text-primary', isButtonBorderColorPrimary && 'border-primary', 'relative', buttonSizeClasses, 'box-border', 'w-full', 'h-full', 'flex', 'justify-center', 'items-center', 'border', 'border-solid', 'rounded-15', 'outline-none', 'focus:outline-none', buttonColorClasses, 'no-underline', 'z-1', 'transition', !isDisabled && (index_module_default())["button--default"], isDisabled && 'pointer-events-none') || ""),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "jsx-3362828503" + " " + "rs-font whitespace-nowrap text-16 font-bold pc:text-15",
          children: children
        })
      }))
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((style_default()), {
      id: "3362828503",
      children: [".wrapper.jsx-3362828503::after{content:'';box-sizing:border-box;position:absolute;width:calc(100% + 8px);height:calc(100% + 8px);top:-4px;left:-4px;border-style:solid;border-width:2px;border-color:transparent;border-radius:18px;}", ".wrapper.focus-visible.jsx-3362828503::after{border-color:".concat(color, ";}"), ".button.bg-primary.jsx-3362828503{background-color:".concat(color, ";}"), ".button.text-primary.jsx-3362828503{color:".concat(color, ";}"), ".button.border-primary.jsx-3362828503{border-color:".concat(color, ";}")]
    })]
  });
});
;// CONCATENATED MODULE: ./src/reservation-page/RSButtonLink/index.tsx


var RSButtonLink_excluded = ["children", "variant", "isBlock", "isDisabled"];

function RSButtonLink_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function RSButtonLink_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? RSButtonLink_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : RSButtonLink_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var RSButtonLink = function RSButtonLink(_ref) {
  var children = _ref.children,
      variant = _ref.variant,
      isBlock = _ref.isBlock,
      isDisabled = _ref.isDisabled,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, RSButtonLink_excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), RSButtonLink_objectSpread(RSButtonLink_objectSpread({}, props), {}, {
    passHref: true,
    legacyBehavior: true,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(RSButtonAnchor, {
      variant: variant,
      isBlock: isBlock,
      isDisabled: isDisabled,
      children: children
    })
  }));
};

/***/ }),

/***/ 42181:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ RSKantanIconButtonAnchor; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59499);
/* harmony import */ var _home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4730);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77521);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _react_aria_focus__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35044);
/* harmony import */ var _react_aria_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(83952);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _index_module_css__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(35858);
/* harmony import */ var _index_module_css__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_index_module_css__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);


var _excluded = ["variant", "isBlock", "isDisabled", "icon", "children"];


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var RSKantanIconButtonAnchor = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(function (_ref, ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'black' : _ref$variant,
      _ref$isBlock = _ref.isBlock,
      isBlock = _ref$isBlock === void 0 ? false : _ref$isBlock,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      icon = _ref.icon,
      children = _ref.children,
      props = (0,_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref, _excluded);

  var _useFocusRing = (0,_react_aria_focus__WEBPACK_IMPORTED_MODULE_6__/* .useFocusRing */ .Fx)(),
      isFocusVisible = _useFocusRing.isFocusVisible,
      focusProps = _useFocusRing.focusProps;

  var color = '#0066FF';
  var wrapperHeightClasses = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function () {
    switch (variant) {
      case 'black':
        return ['h-48', 'pc:h-44'];
    }
  }, [variant]);
  var buttonSizeClasses = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function () {
    switch (variant) {
      case 'black':
        return ['px-2'];
    }
  }, [variant]);
  var buttonColorClasses = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function () {
    switch (variant) {
      case 'black':
        return [!isDisabled ? 'bg-black' : 'bg-gray-10', !isDisabled ? 'text-white' : 'text-gray-200', !isDisabled ? 'border-none' : 'border-gray-10'];
    }
  }, [variant, isDisabled]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
      className: "jsx-3362828503" + " " + (classnames__WEBPACK_IMPORTED_MODULE_3___default()('wrapper', isFocusVisible && 'focus-visible', !isBlock ? 'inline-block' : ['block', 'w-full'], 'relative', wrapperHeightClasses, 'rounded-15', 'after:transition', // cursor-event-noneとcursor-not-allowedを同じ要素で利用できないため
      !isDisabled ? 'cursor-pointer' : 'cursor-not-allowed') || ""),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("a", _objectSpread(_objectSpread({}, (0,_react_aria_utils__WEBPACK_IMPORTED_MODULE_7__/* .mergeProps */ .dG)(props, focusProps)), {}, {
        ref: ref,
        tabIndex: !isDisabled ? undefined : -1,
        className: "jsx-3362828503" + " " + (classnames__WEBPACK_IMPORTED_MODULE_3___default()('button', 'relative', buttonSizeClasses, 'box-border', 'w-full', 'h-full', 'flex', 'justify-center', 'items-center', 'border', 'border-solid', 'rounded-15', 'outline-none', 'focus:outline-none', buttonColorClasses, 'no-underline', 'z-1', 'transition', icon && 'gap-0.5', !isDisabled && (_index_module_css__WEBPACK_IMPORTED_MODULE_8___default()["button--default"]), isDisabled && 'pointer-events-none') || ""),
        children: [icon && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
          className: "jsx-3362828503" + " " + "flex-none",
          children: icon
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
          className: "jsx-3362828503" + " " + "rs-font whitespace-nowrap text-16 font-bold pc:text-15",
          children: children
        })]
      }))
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((styled_jsx_style__WEBPACK_IMPORTED_MODULE_0___default()), {
      id: "3362828503",
      children: [".wrapper.jsx-3362828503::after{content:'';box-sizing:border-box;position:absolute;width:calc(100% + 8px);height:calc(100% + 8px);top:-4px;left:-4px;border-style:solid;border-width:2px;border-color:transparent;border-radius:18px;}", ".wrapper.focus-visible.jsx-3362828503::after{border-color:".concat(color, ";}"), ".button.bg-primary.jsx-3362828503{background-color:".concat(color, ";}"), ".button.text-primary.jsx-3362828503{color:".concat(color, ";}"), ".button.border-primary.jsx-3362828503{border-color:".concat(color, ";}")]
    })]
  });
});

/***/ }),

/***/ 94348:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[publicId]/[resource_id]",
      function () {
        return __webpack_require__(56020);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 82011:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button--default":"RSButtonAnchor_button--default__zFPnB","icon-wrapper":"RSButtonAnchor_icon-wrapper__Gol21","spin":"RSButtonAnchor_spin__7YM1v"};

/***/ }),

/***/ 35858:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button--default":"RSKantanIconButtonAnchor_button--default__7AvsH","icon-wrapper":"RSKantanIconButtonAnchor_icon-wrapper___OnuN","spin":"RSKantanIconButtonAnchor_spin__xWYbX"};

/***/ }),

/***/ 57271:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Lightbox":"Lightbox_Lightbox__l_1TM","Lightbox__List":"Lightbox_Lightbox__List__Kn_L0","Lightbox__Button":"Lightbox_Lightbox__Button__lOs6j","Lightbox__Thumbnail":"Lightbox_Lightbox__Thumbnail__BOB2r"};

/***/ }),

/***/ 97930:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"GoogleMap":"GoogleMap_GoogleMap___Z0o8","GoogleMap__Address":"GoogleMap_GoogleMap__Address__6pasU","GoogleMap__Image":"GoogleMap_GoogleMap__Image__0ioqr"};

/***/ }),

/***/ 52890:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"DescriptionPanel":"DescriptionPanel_DescriptionPanel__hYPjw"};

/***/ }),

/***/ 38267:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"SwitchContainerButton":"SwitchContainerButton_SwitchContainerButton__jp2tc","SwitchContainerButton__Label":"SwitchContainerButton_SwitchContainerButton__Label__dfPY_","SwitchContainerButton__Input":"SwitchContainerButton_SwitchContainerButton__Input__3EhUt","isSelected":"SwitchContainerButton_isSelected__no9BV"};

/***/ }),

/***/ 51356:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"TruncateTextWithButton":"TruncateTextWithButton_TruncateTextWithButton__heM61","TruncateTextWithButton__Text":"TruncateTextWithButton_TruncateTextWithButton__Text__0vLmd","TruncateTextWithButton__Button":"TruncateTextWithButton_TruncateTextWithButton__Button__uZ35k"};

/***/ }),

/***/ 92706:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"LowestPrice":"LowestPrice_LowestPrice__ZU1tL","LowestPrice__Emphasis":"LowestPrice_LowestPrice__Emphasis__5HvM8"};

/***/ }),

/***/ 725:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"MerchantCourseDetailsReservationButton":"MerchantCourseDetailsReservationButton_MerchantCourseDetailsReservationButton__rxzLg","MerchantCourseDetailsReservationButton__Button":"MerchantCourseDetailsReservationButton_MerchantCourseDetailsReservationButton__Button__xbTyW"};

/***/ }),

/***/ 5470:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"MerchantBookingServiceShowPage":"MerchantBookingServiceShowPage_MerchantBookingServiceShowPage__Ahsrg","MerchantBookingServiceShowPage__Heading":"MerchantBookingServiceShowPage_MerchantBookingServiceShowPage__Heading__NAd6Y","MerchantBookingServiceShowPage__HeroImage":"MerchantBookingServiceShowPage_MerchantBookingServiceShowPage__HeroImage__0lR4y","MerchantBookingServiceShowPage__Embed":"MerchantBookingServiceShowPage_MerchantBookingServiceShowPage__Embed__s35hg","MerchantBookingServiceShowPage__Section":"MerchantBookingServiceShowPage_MerchantBookingServiceShowPage__Section__X7l4N","MerchantBookingServiceShowPage__ReviewLink":"MerchantBookingServiceShowPage_MerchantBookingServiceShowPage__ReviewLink__tRi5t","MerchantBookingServiceShowPage__ButtonContainer":"MerchantBookingServiceShowPage_MerchantBookingServiceShowPage__ButtonContainer__7_akw","MerchantBookingServiceShowPage__ReviewLinkIcon":"MerchantBookingServiceShowPage_MerchantBookingServiceShowPage__ReviewLinkIcon__PL1_W","MerchantBookingServiceShowPage__MerchantProfileSection":"MerchantBookingServiceShowPage_MerchantBookingServiceShowPage__MerchantProfileSection__ppFlL","MerchantBookingServiceShowPage__BackToTopButtonSection":"MerchantBookingServiceShowPage_MerchantBookingServiceShowPage__BackToTopButtonSection__1lv7I","MerchantBookingServiceShowPage__BackToTopButton":"MerchantBookingServiceShowPage_MerchantBookingServiceShowPage__BackToTopButton__GAab9"};

/***/ }),

/***/ 63623:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Course":"Course_Course__zZyX8","Course__Header":"Course_Course__Header__OHrzj","Course__Image":"Course_Course__Image__qkZ9Z","Course__Description":"Course_Course__Description__EzKb6","Course__Button":"Course_Course__Button__88Itg"};

/***/ }),

/***/ 90501:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"CourseDetail":"CourseDetail_CourseDetail__CI2Jz","CourseDetail__Detail":"CourseDetail_CourseDetail__Detail__8OP9U","CourseDetail__Time":"CourseDetail_CourseDetail__Time__N8AcN"};

/***/ }),

/***/ 29269:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Staff":"Staff_Staff__h9tHC","Staff__Img":"Staff_Staff__Img__7gZeh","Staff__Texts":"Staff_Staff__Texts__kGi0T","Staff__Name":"Staff_Staff__Name__gFvNx","Staff__Description":"Staff_Staff__Description__Ql_lj","Staff__ButtonContainer":"Staff_Staff__ButtonContainer__aLXx1","Staff__Button":"Staff_Staff__Button__Tz1Pl"};

/***/ }),

/***/ 79038:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"SwitchCourseStaff":"SwitchCourseStaff_SwitchCourseStaff__gjfjA"};

/***/ }),

/***/ 35490:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Appointment":"Appointment_Appointment__JlQ7_","Appointment__Content":"Appointment_Appointment__Content__uTUnZ"};

/***/ }),

/***/ 11901:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"MerchantCourseDetailsHeader":"MerchantCourseDetailsHeader_MerchantCourseDetailsHeader__G8Bif","MerchantCourseDetailsHeader__Inner":"MerchantCourseDetailsHeader_MerchantCourseDetailsHeader__Inner__7ACcw","MerchantCourseDetailsHeader__Header":"MerchantCourseDetailsHeader_MerchantCourseDetailsHeader__Header__a2hwP","MerchantCourseDetailsHeader__Title":"MerchantCourseDetailsHeader_MerchantCourseDetailsHeader__Title__9kUVt","MerchantCourseDetailsHeader__Summary":"MerchantCourseDetailsHeader_MerchantCourseDetailsHeader__Summary__pbhNl","MerchantCourseDetailsHeader__StarRating":"MerchantCourseDetailsHeader_MerchantCourseDetailsHeader__StarRating__Olzcb","MerchantCourseDetailsHeader__ReviewCount":"MerchantCourseDetailsHeader_MerchantCourseDetailsHeader__ReviewCount__FSQAJ","MerchantCourseDetailsHeader__Price":"MerchantCourseDetailsHeader_MerchantCourseDetailsHeader__Price__FCIxh","MerchantCourseDetailsHeader__Notice":"MerchantCourseDetailsHeader_MerchantCourseDetailsHeader__Notice__svsfo","MerchantCourseDetailsHeader__ButtonContainer":"MerchantCourseDetailsHeader_MerchantCourseDetailsHeader__ButtonContainer__3rLZ6","MerchantCourseDetailsHeader__SummaryContainer":"MerchantCourseDetailsHeader_MerchantCourseDetailsHeader__SummaryContainer__mLO0y"};

/***/ }),

/***/ 55960:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"MerchantCourseDetailsHeaderImage":"MerchantCourseDetailsHeaderImage_MerchantCourseDetailsHeaderImage__odeb0","isLargePortrait":"MerchantCourseDetailsHeaderImage_isLargePortrait__rpZhL","isMiddle":"MerchantCourseDetailsHeaderImage_isMiddle__k6kN8","isSmall":"MerchantCourseDetailsHeaderImage_isSmall__hdyJs","isTiny":"MerchantCourseDetailsHeaderImage_isTiny__cIXIN"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1966,2595,8888,5974,4778,9267,3253,320,8017,2419,301,2218,1080,1878,7356,719,3202,4754,6339,8769,9373,1666,9774,2888,179], function() { return __webpack_exec__(94348); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);